import * as React from "react";
const SvgTonicValidateIcon = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18" }, props),
    React.createElement("path", { fill: "#00DCDC", d: "M18 0h-3.648L0 14.354V18h3.64L18 3.646V0Z" }),
    React.createElement("path", { fill: "url(#TonicValidateIcon_svg__a)", d: "M5.148 3.214H0v11.14L5.148 9.2V3.214Z" }),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "TonicValidateIcon_svg__a", x1: 4.875, x2: -0.09, y1: 9.477, y2: 4.509, gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { stopColor: "#008F8F" }),
            React.createElement("stop", { offset: 1, stopColor: "#00DCDC" })))));
export default SvgTonicValidateIcon;
